/* Pure rules shared by storefront behavior and local regression tests. */
(() => {
  'use strict';
  function money(cents, currency='USD', locale='en', codes=false) {
    const formatter=new Intl.NumberFormat(locale,{style:'currency',currency});
    const amount=Number(cents||0)/100, value=formatter.format(amount);
    const displayedCurrency=formatter.formatToParts(amount).find(part=>part.type==='currency')?.value;
    return codes && displayedCurrency!==currency ? value+' '+currency : value;
  }
  function threshold(text,currency,country) {
    let general,scoped;
    for(const line of String(text||'').split(/\r?\n/)) {
      const match=line.trim().toUpperCase().match(/^(?:([A-Z]{2}):)?([A-Z]{3}):([0-9]+(?:\.[0-9]{1,2})?)$/);
      if(!match||match[2]!==currency)continue;
      const cents=Math.round(Number(match[3])*100);
      if(!Number.isSafeInteger(cents)||cents<=0)continue;
      if(match[1]===country)scoped=cents;else if(!match[1])general=cents;
    }
    return scoped??general??null;
  }
  function shippingProgress(total,goal) {
    if(!Number.isSafeInteger(goal)||goal<=0)return null;
    const amount=Math.max(0,goal-Math.max(0,total));
    return {amount,percent:Math.max(0,Math.min(100,total/goal*100)),state:amount===0?'reached':total>=goal*.8?'close':'standard'};
  }
  function nearWord(term,word) {
    if(word.includes(term))return true;
    if(term.length<5||term.slice(0,4)!==word.slice(0,4))return false;
    const candidate=word.slice(0,term.length+1);
    for(const value of [candidate,candidate.slice(0,term.length)]) {
      if(Math.abs(value.length-term.length)>1)continue;
      let a=0,b=0,edits=0;
      while(a<term.length&&b<value.length){
        if(term[a]===value[b]){a++;b++;continue;}
        if(++edits>1)break;
        if(term[a]===value[b+1]&&term[a+1]===value[b]){a+=2;b+=2;}
        else if(term.length>value.length)a++;else if(value.length>term.length)b++;else{a++;b++;}
      }
      if(edits+(term.length-a)+(value.length-b)<=1)return true;
    }
    return false;
  }
  function searchMatches(product,query,config={},type='') {
    if(type&&(product.type||product.product_type)!==type)return false;
    const variants=product.variants||[];
    const core=[product.title,product.vendor,product.type||product.product_type,...variants.map(v=>v.title)].filter(Boolean).join(' ').toLocaleLowerCase();
    const optional=[];
    if(config.searchDescription)optional.push(product.description||product.body);
    if(config.searchSku)optional.push(...variants.map(v=>v.sku));
    if(config.searchBarcode)optional.push(...variants.map(v=>v.barcode));
    if(config.searchTags)optional.push(...(product.tags||[]));
    const text=optional.filter(Boolean).join(' ').replace(/<[^>]*>/g,' ').toLocaleLowerCase();
    const words=core.split(/\s+/);
    return query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean).every(term=>text.includes(term)||core.includes(term)||words.some(word=>nearWord(term,word)));
  }
  const api={money,threshold,shippingProgress,searchMatches};
  if(typeof window!=='undefined')window.PawCommerceEngine=api;
  if(typeof module!=='undefined')module.exports=api;
})();
